(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["penguin-hero-bkp"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    function initHeroVideo(container) {
      const videos = container.querySelectorAll('.penguin-hero-glass__video');
      
      videos.forEach(video => {
        // Garantir que o vídeo seja reproduzido
        video.muted = true;
        video.playsInline = true;
        
        // Tentar reproduzir o vídeo
        const playPromise = video.play();
        
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            // Auto-play foi prevenido, tentar novamente
            console.log('Video autoplay prevented, retrying...', error);
            setTimeout(() => {
              video.play().catch(e => console.log('Retry failed', e));
            }, 100);
          });
        }
      });
    }

    // Inicializar ao carregar
    document.addEventListener('DOMContentLoaded', function() {
      const heroSection = document.querySelector('[data-section-id="{{ section.id }}"]');
      if (heroSection) {
        initHeroVideo(heroSection);
      }
    });

    // Reinicializar no Theme Editor
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId === '{{ section.id }}') {
        const heroSection = document.querySelector('[data-section-id="{{ section.id }}"]');
        if (heroSection) {
          initHeroVideo(heroSection);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["penguin-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    function initHeroVideo(container) {
      const videos = container.querySelectorAll('.penguin-hero-glass__video');
      
      videos.forEach(video => {
        // Garantir que o vídeo seja reproduzido
        video.muted = true;
        video.playsInline = true;
        
        // Tentar reproduzir o vídeo
        const playPromise = video.play();
        
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            // Auto-play foi prevenido, tentar novamente
            console.log('Video autoplay prevented, retrying...', error);
            setTimeout(() => {
              video.play().catch(e => console.log('Retry failed', e));
            }, 100);
          });
        }
      });
    }

    // Inicializar ao carregar
    document.addEventListener('DOMContentLoaded', function() {
      const heroSection = document.querySelector('[data-section-id="{{ section.id }}"]');
      if (heroSection) {
        initHeroVideo(heroSection);
      }
    });

    // Reinicializar no Theme Editor
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId === '{{ section.id }}') {
        const heroSection = document.querySelector('[data-section-id="{{ section.id }}"]');
        if (heroSection) {
          initHeroVideo(heroSection);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["penguin-trusted-brands-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const carousel = document.querySelector(".trusted-brands__carousel");
  const left = document.querySelector(".trusted-carousel__arrow--left");
  const right = document.querySelector(".trusted-carousel__arrow--right");

  if (!carousel || !left || !right) return;

  const updateArrowVisibility = () => {
    const scrollable = carousel.scrollWidth > carousel.clientWidth + 5;
    left.style.display = scrollable ? "flex" : "none";
    right.style.display = scrollable ? "flex" : "none";
  };

  updateArrowVisibility();
  window.addEventListener("resize", updateArrowVisibility);

  const getScrollAmount = () => {
    const item = carousel.querySelector(".trusted-brands__item");
    const style = window.getComputedStyle(carousel);
    const gap = parseInt(style.gap) || 16;
    return (item?.offsetWidth || 300) + gap;
  };

  left.addEventListener("click", () => {
    const amount = getScrollAmount();
    if (carousel.scrollLeft <= 0) {
      carousel.scrollTo({ left: carousel.scrollWidth, behavior: "smooth" });
    } else {
      carousel.scrollBy({ left: -amount, behavior: "smooth" });
    }
  });

  right.addEventListener("click", () => {
    const amount = getScrollAmount();
    const end = carousel.scrollLeft + carousel.clientWidth;
    if (end >= carousel.scrollWidth - 1) {
      carousel.scrollTo({ left: 0, behavior: "smooth" });
    } else {
      carousel.scrollBy({ left: amount, behavior: "smooth" });
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["penguin-video-testimonials"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".video-testimonials__carousel-container");
  const carousel = document.querySelector(".video-testimonials__carousel");
  const left = document.querySelector(".video-carousel__arrow--left");
  const right = document.querySelector(".video-carousel__arrow--right");

  if (!carousel || !container || !left || !right) return;

  // --- mostra ou esconde setas dinamicamente ---
  const updateArrowVisibility = () => {
    const scrollable = container.scrollWidth > container.clientWidth + 5;
    left.style.display = scrollable ? "flex" : "none";
    right.style.display = scrollable ? "flex" : "none";
  };

  updateArrowVisibility();
  window.addEventListener("resize", updateArrowVisibility);

  // --- calcula quanto deve rolar ---
  const getScrollAmount = () => {
    const item = carousel.querySelector(".video-testimonials__item");
    const style = window.getComputedStyle(carousel);
    const gap = parseInt(style.gap) || 16;
    return (item?.offsetWidth || 320) + gap;
  };

  // --- rola para a esquerda (com loop infinito) ---
  left.addEventListener("click", () => {
    const amount = getScrollAmount();
    if (container.scrollLeft <= 0) {
      // vai para o final suavemente
      container.scrollTo({ left: container.scrollWidth, behavior: "smooth" });
    } else {
      container.scrollBy({ left: -amount, behavior: "smooth" });
    }
  });

  // --- rola para a direita (com loop infinito) ---
  right.addEventListener("click", () => {
    const amount = getScrollAmount();
    const end = container.scrollLeft + container.clientWidth;
    if (end >= container.scrollWidth - 1) {
      // volta para o início
      container.scrollTo({ left: 0, behavior: "smooth" });
    } else {
      container.scrollBy({ left: amount, behavior: "smooth" });
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
